module.exports = __webpack_public_path__ + "static/media/logo.d79d8552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 739
// module chunks = 0